<template>
    <div>
        <!-- 面包屑导航 -->
        <el-breadcrumb separator-class="el-icon-arrow-right">
            <el-breadcrumb-item :to="{ path: '/' }">首页</el-breadcrumb-item>
            <el-breadcrumb-item>协议与说明</el-breadcrumb-item>
        </el-breadcrumb>

        <div class="title">{{listData.agreement_title}}</div>
        <div class="content" v-html="listData.agreement_content"></div>
    </div>
</template>

<script>
    import {agreement, deleteAgreement, saveAgreement} from "../../api/userMG";
    export default {
        data() {
            return {
                loading: false, //是显示加载
                title: '协议与说明',
                formInline: {
                    page: 1,
                    limit: 10,
                    pageSize: 10
                },
                listData: [], //用户数据
                // 分页参数
                pageparm: {
                    currentPage: 1,
                    pageSize: 10,
                    total: 10
                },
            }
        },
        // 注册组件
        components: {
        },
        /**
         * 创建完毕
         */
        created() {
            this.getdata(this.formInline)
        },

        /**
         * 里面的方法只有被调用才会执行
         */
        methods: {
            getdata(parameter) {
                this.loading = true
                agreement(parameter).then(res => {
                    if(res.code == 200){
                        this.listData = res.result
                        this.loading = false
                    }
                })
            }
        }
    }
</script>

<style scoped>
    .title {
        margin-top: 20px;
        text-align: center;
        font-size: 1.2rem;
        margin-bottom: 6vh;
    }
</style>


// WEBPACK FOOTER //
// src/views/protocal/protocal.vue